<template>
  <div>
      正在登录统一门户
  </div>
</template>
<script>
/* eslint-disable */ 
import * as dd from "dingtalk-jsapi";
export default {
  data(){
      return {
          titleName: '',
          corpId: '',
          appSign:''
      }
  },
  watch: {
      '$route':{
          handler() {
              this.dindin(this.corpId,this.appSign)
          },
          deep: true
      }
  },
  created(){
      this.initData()
  },
  mounted() {
  },
  methods:{
      dindin(corpId,appSign) {
          console.log(corpId, appSign,'corpId22222')
          if (dd.env.platform !== "notInDingTalk") {
              dd.ready(function() {
                  dd.runtime.permission.requestAuthCode({
                      corpId: corpId,
                      onSuccess: function (info) {
                          window.location.href = `${window.location.origin}/sso/dingDing/autoLoginByCode?appSign=${appSign}&corpId=${corpId}&code=${info.code}`;
                      }, 
                      onFail: function(err){
                          alert(err.errorMessage)
                      }
                      });
              });
          }
      },
      initData() {
        let url = window.location.href.split('?')[1]
        this.appSign = (url.split('=')[1]).split('&')[0]
        this.corpId = (url.split('&')[1]).split('=')[1]
        this.dindin(this.corpId,this.appSign)
      }
    }
  }
</script>